<template>
  <mymodal ref="theModal" :need-header="true" :need-footer="false" :size="'medium'">
    <div slot="title">{{'Edit'|translate}}</div>
    <div slot="body" class="in-modal search-market">
      <insert-market
        :user="user"
        :list_payments="list_payments"
        :pass_data="item"
        :types="types"
        :allProducts="allProducts"
        @refresh="refresh"
      ></insert-market>
    </div>
  </mymodal>
</template>
<script>
import mymodal from "@/components/elements/Modal";
import Utils from "@/helpers/utils";
import InsertMarket from "@/components/elements/InsertMarket";
//import GoogleAutocomplete from 'google-autocomplete-vue';
export default {
  name: "EditMarket",
  components: {
    mymodal,
    InsertMarket
  },
  props: ["user", "types", "list_payments", "allProducts", "item"],
  data() {
    return {};
  },
  created() {
    // clone from original params
  },
  methods: {
    open() {
      this.$refs.theModal.open();
    },
    refresh() {
      this.$emit("refresh", {});
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/elements/EditMarket.vue